export const float = float => {
    return parseFloat(parseFloat(float).toFixed(2));
}

export const int = int => {
    return parseInt(int) || 0;
}

export const phoneFormat = value => {
    if(value.length > 10) value = value.substr(1);

    let pattern = `+1 (NNN) NNN NN-NN`,
        phone = "",
        char_index = 0;

    for(let i = 0; i < pattern.length; i++)
        if(pattern[i] === "N") {
            phone += value[char_index];
            char_index++;
        } else {
            phone += pattern[i];
        }

    return phone;
}